export const LoginMethods = {
	PASSWORD: 'password',
	SSO: 'sso',
	MISSING: 'missing',
} as const;

export type LoginMethod = typeof LoginMethods[keyof typeof LoginMethods];

// Auth0 user ids are prefixed with the provider, e.g. `auth0|...` for username/password
// and `waad|...` for Microsoft (Azure AD) SSO
export const getLoginMethod = (providerId: string | null | undefined): LoginMethod => {
	if (providerId == null || providerId.trim() === '') {
		return LoginMethods.MISSING;
	}

	if (providerId.startsWith('auth0|')) {
		return LoginMethods.PASSWORD;
	}

	return LoginMethods.SSO;
};
